import React from "react";
import { Container } from "inversify";

/**
 * Defines the context to support the container.
 */
interface ContainerContext {
  container: Container | null;
}

/**
 * Defines the context to use Inversify
 * container to resolve dependencies.
 */
export const InversifyContext = React.createContext<ContainerContext>({
  container: null,
});

/**
 * Defines props for the provider.
 */
interface ContainerProviderProperties {
  container: Container;
  children: React.ReactNode;
}

/**
 * Defines the React component to provide the container to the child components.
 */
export const ContainerProvider: React.FC<ContainerProviderProperties> = ({ container, children }) => <InversifyContext.Provider value={{ container }}>{children}</InversifyContext.Provider>;
